/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Pencil, Eye,  UserPlus, MoreVertical, Mail, Shield, Search, ChevronLeft, ChevronRight, Info, KeyRound, EyeOff } from 'lucide-react';
import { useSelector } from 'react-redux';

import Page from '../../../components/Page';
import Modal from '../../../components/modal/Index';
import tenantUserSvc from '../../../services/clientAdmin/tenantUserServices';
import { KNOWN_EMAIL_DOMAINS } from '../../../website/pages/Domain'

const PAGE_SIZE = 10;

function initials(first = '', last = '') {
    return `${first[0] || ''}${last[0] || ''}`.toUpperCase() || '?';
}

function Avatar({ first, last, size = 'md' }) {
    const sz = size === 'lg' ? 'w-12 h-12 text-base' : 'w-8 h-8 text-xs';
    return (
        <div className={`${sz} rounded-full bg-purple-600 text-white font-semibold flex items-center justify-center flex-shrink-0 select-none`}>
            {initials(first, last)}
        </div>
    );
}

function StatusPill({ status }) {
    return (
        <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${status === 'ACTIVE' ? 'bg-emerald-50 text-emerald-700' : 'bg-gray-100 text-gray-500'
            }`}>
            {status === 'ACTIVE' ? 'Active' : 'Inactive'}
        </span>
    );
}

function validateNames(firstName, lastName, isEdit = false) {
    if (!firstName || !firstName.trim()) {
        return 'First name is required.';
    }
    if (firstName !== firstName.trim()) {
        return 'First name must not have leading or trailing spaces.';
    }
    if (!/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(firstName.trim())) {
        return 'First name must contain only letters.';
    }

    if (lastName && lastName.trim()) {
        if (lastName !== lastName.trim()) {
            return 'Last name must not have leading or trailing spaces.';
        }
        if (!/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(lastName.trim())) {
            return 'Last name must contain only letters.';
        }
    } else if (lastName && !lastName.trim()) {
        return 'Last name cannot be spaces only.';
    }

    return '';
}
const EMAIL_REGEX = /^[A-Za-z0-9_%+-]+(?:\.[A-Za-z0-9_%+-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;
const VALID_TLDS = new Set([
  'com','net','org','edu','gov','mil','int','co','io','ai','app','dev',
  'in','us','uk','ca','au','de','fr','it','es','nl','se','no','dk','fi',
  'jp','cn','kr','ru','br','mx','za','sg','hk','nz','ch','at','be','pl',
  'info','biz','me','tv','xyz','online','site','tech','store','shop',
  'edu.in','co.in','co.uk','com.au','co.jp','com.br','co.za'
]);

function isValidTld(domain) {
  const lower = domain.toLowerCase();
  const parts = lower.split('.');
  const lastTwo = parts.slice(-2).join('.');
  const lastOne = parts.slice(-1).join('.');
  return VALID_TLDS.has(lastTwo) || VALID_TLDS.has(lastOne);
}

function validateEmail(email) {
    const value = (email || '').trim();
    if (!value) {
        return 'Email is required.';
    }
    if (value.length > 254) {
        return 'Email is too long.';
    }
    if (!EMAIL_REGEX.test(value)) {
        return 'Please enter a valid email address.';
    }
    const domain = value.split('@')[1];
    if (!isValidTld(domain)) {
        return 'Please enter a valid email address.';
    }

    const suggestion = checkEmailDomainTypo(value);
    if (suggestion) {
        return `Invalid email domain. Did you mean @${suggestion}?`;
    }
    return '';
}

  const levenshtein = (a, b) => {
    const matrix = Array.from({ length: a.length + 1 }, (_, i) =>
      Array.from({ length: b.length + 1 }, (_, j) => {
        if (i === 0) return j;
        if (j === 0) return i;
        return 0;
      })
    );

    a.split('').forEach((charA, i) => {
      b.split('').forEach((charB, j) => {
        const row = i + 1;
        const col = j + 1;
        matrix[row][col] = charA === charB
          ? matrix[row - 1][col - 1]
          : 1 + Math.min(
            matrix[row - 1][col],
            matrix[row][col - 1],
            matrix[row - 1][col - 1]
          );
      });
    });

    return matrix[a.length][b.length];
  };

function checkEmailDomainTypo(email) {
    if (!email || !email.includes('@')) return undefined;

    const domain = email.split('@')[1]?.toLowerCase().trim();
    if (!domain) return undefined;

    if (KNOWN_EMAIL_DOMAINS.includes(domain)) {
        return null;
    }

    const { closest, closestDistance } = KNOWN_EMAIL_DOMAINS.reduce(
        (acc, known) => {
            const dist = levenshtein(domain, known);
            return dist < acc.closestDistance
                ? { closest: known, closestDistance: dist }
                : acc;
        },
        { closest: null, closestDistance: Infinity }
    );

    const threshold = Math.min(3, Math.ceil(closest.length * 0.3));

    if (closestDistance > 0 && closestDistance <= threshold) {
        return closest;
    }

    return undefined;
}
function ConfirmModal({ creator, onConfirm, onCancel }) {
    const isDeactivating = creator.status === 'ACTIVE';
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
            <div className="absolute inset-0 bg-black/40" onClick={onCancel} />
            <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 z-10">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-4 ${isDeactivating ? 'bg-red-50' : 'bg-emerald-50'}`}>
                    {isDeactivating
                        ? <span className="text-red-500 text-lg">!</span>
                        : <span className="text-emerald-500 text-lg">+</span>
                    }
                </div>

                <h3 className="text-base font-semibold text-gray-900 mb-1">
                    {isDeactivating ? 'Deactivate Content Creator' : 'Activate Content Creator'}
                </h3>

                <p className="text-sm text-gray-500 mb-6">
                    {isDeactivating
                        ? <>Deactivate <span className="font-medium text-gray-800">"{creator.firstName} {creator.lastName}"</span>? They will lose access to the content bank. This can be reversed.</>
                        : <>Activate <span className="font-medium text-gray-800">"{creator.firstName} {creator.lastName}"</span>? They will regain access to the content bank.</>
                    }
                </p>

                <div className="flex gap-2">
                    <button
                        onClick={onCancel}
                        className="flex-1 py-2.5 text-sm border border-gray-200 rounded-xl text-gray-600 hover:bg-gray-50 font-medium"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`flex-1 py-2.5 text-sm rounded-xl text-white font-medium ${isDeactivating
                            ? 'bg-red-500 hover:bg-red-600'
                            : 'bg-emerald-500 hover:bg-emerald-600'
                            }`}
                    >
                        {isDeactivating ? 'Yes, Deactivate' : 'Yes, Activate'}
                    </button>
                </div>
            </div>
        </div>
    );
}

function CreatorDrawer({ mode, creator, onClose, onSaved }) {
    const isView = mode === 'view';
    const isEdit = mode === 'edit';
    const isInactive = isEdit && creator?.status !== 'ACTIVE';

    const [showPwd, setShowPwd] = useState({
        newPassword: false, confirmNewPassword: false,
    });
    const togglePwd = (field) => setShowPwd(p => ({ ...p, [field]: !p[field] }));
    const [form, setForm] = useState({
        firstName: creator?.firstName || '',
        lastName: creator?.lastName || '',
        email: creator?.email || '',
        newPassword: '',
        confirmNewPassword: '',
    });
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);
    const [showDiscard, setShowDiscard] = useState(false);
    const [isDirty, setIsDirty] = useState(false);

    const set = (k, v) => {
        setForm(f => ({ ...f, [k]: v }));
        setErrors(prev => ({ ...prev, [k]: '', general: '' }));
        setIsDirty(true);
    };

    const handleCloseAttempt = () => {
        if (!isView && isDirty) {
            setShowDiscard(true);
        } else {
            onClose();
        }
    };

    const handleDiscardConfirm = () => {
        setShowDiscard(false);
        onClose();
    };

    const validateNameField = (field, value) => {
        if (field === 'firstName') {
            if (!value || !value.trim()) {
                setErrors(prev => ({ ...prev, firstName: 'First name is required.' }));
            } else if (value !== value.trim()) {
                setErrors(prev => ({ ...prev, firstName: 'Must not have leading or trailing spaces.' }));
            } else if (!/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(value.trim())) {
                setErrors(prev => ({ ...prev, firstName: 'Must contain only letters.' }));
            } else {
                setErrors(prev => ({ ...prev, firstName: '' }));
            }
        }
        if (field === 'lastName') {
            if (value && !value.trim()) {
                setErrors(prev => ({ ...prev, lastName: 'Last name cannot be spaces only.' }));
            } else if (value && value !== value.trim()) {
                setErrors(prev => ({ ...prev, lastName: 'Must not have leading or trailing spaces.' }));
            } else if (value && !/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(value.trim())) {
                setErrors(prev => ({ ...prev, lastName: 'Must contain only letters.' }));
            } else {
                setErrors(prev => ({ ...prev, lastName: '' }));
            }
        }
    };

    const validatePasswordField = (field, value) => {
        if (!value) {
            setErrors(prev => ({ ...prev, [field]: '' }));
            return;
        }
        if (value.startsWith(' ')) {
            setErrors(prev => ({ ...prev, [field]: 'Password must not start with a space.' }));
        } else if (value.length < 4) {
            setErrors(prev => ({ ...prev, [field]: 'Password must be at least 4 characters.' }));
        } else {
            setErrors(prev => ({ ...prev, [field]: '' }));
        }
    };

    const handleSubmit = async () => {
        const nameErr = validateNames(form.firstName, form.lastName, isEdit);
        if (nameErr) {
            if (nameErr.toLowerCase().includes('first')) {
                setErrors(prev => ({ ...prev, firstName: nameErr }));
            } else if (nameErr.toLowerCase().includes('last')) {
                setErrors(prev => ({ ...prev, lastName: nameErr }));
            } else {
                setErrors(prev => ({ ...prev, general: nameErr }));
            }
            return;
        }

        if (!isEdit) {
            if (!form.email.trim()) {
                setErrors(prev => ({ ...prev, email: 'Email is required.' }));
                return;
            }
        }

        if (isEdit && !isInactive && form.newPassword) {
            if (form.newPassword.startsWith(' ')) {
                setErrors(prev => ({ ...prev, newPassword: 'Password must not start with a space.' }));
                return;
            }
            if (form.newPassword.length < 4) {
                setErrors(prev => ({ ...prev, newPassword: 'New password must be at least 4 characters.' }));
                return;
            }
            if (form.newPassword !== form.confirmNewPassword) {
                setErrors(prev => ({ ...prev, confirmNewPassword: 'Passwords do not match.' }));
                return;
            }
        }

        setSaving(true);
        let res;
        if (isEdit) {
            const payload = {
                firstName: form.firstName.trim(),
                lastName: form.lastName.trim(),
            };
            if (!isInactive && form.newPassword) payload.newPassword = form.newPassword;
            res = await tenantUserSvc.updateTenantUser(creator.id, payload);
        } else {
            res = await tenantUserSvc.createTenantUser({
                firstName: form.firstName.trim(),
                lastName: form.lastName.trim(),
                email: form.email.trim(),
                password: form.password,
                roleCode: 'CONTENT_WRITER',
            });
        }
        setSaving(false);

        if (res.ok) { onSaved(); }
        else { setErrors(prev => ({ ...prev, general: res.data?.message || 'Something went wrong.' })); }
    };

    const title = isView ? 'Creator Details' : isEdit ? 'Edit Content Creator' : 'Add Content Creator';

    const FieldError = ({ field }) =>
        errors[field] ? <p className="text-xs text-red-500 mt-1">{errors[field]}</p> : null;

    const inputCls = (field) =>
        `w-full border rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-200 ${errors[field] ? 'border-red-400' : 'border-gray-200'
        }`;

    return (
        <>
            <Modal title={title} open={true} toggle={handleCloseAttempt}>
                <div className="flex flex-col" style={{ height: 'calc(100vh - 80px)' }}>

                    <div className="flex-1 px-2 py-5 space-y-4 overflow-y-auto">
                        {isView ? (
                            <div className="space-y-4">
                                <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl">
                                    <Avatar first={creator.firstName} last={creator.lastName} size="lg" />
                                    <div>
                                        <p className="font-semibold text-gray-900 text-sm">{creator.firstName} {creator.lastName}</p>
                                        <p className="text-xs text-gray-500 mt-0.5 truncate">{creator.email}</p>
                                        <div className="mt-1.5"><StatusPill status={creator.status} /></div>
                                    </div>
                                </div>
                                <div className="divide-y divide-gray-100 rounded-xl border border-gray-100 overflow-hidden">
                                    {[
                                        { label: 'Full Name', value: `${creator.firstName} ${creator.lastName}` },
                                        { label: 'Email', value: creator.email },
                                        { label: 'Role', value: 'Content Writer' },
                                    ].map(row => (
                                        <div key={row.label} className="flex items-center justify-between px-4 py-3 bg-white gap-3">
                                            <span className="text-xs text-gray-500 flex-shrink-0">{row.label}</span>
                                            <span className="text-sm text-gray-800 font-medium truncate text-right">{row.value}</span>
                                        </div>
                                    ))}
                                    <div className="flex items-center justify-between px-4 py-3 bg-white">
                                        <span className="text-xs text-gray-500">Status</span>
                                        <StatusPill status={creator.status} />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="space-y-5">
                                <div>
                                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Profile</p>
                                    <div className="space-y-3">
                                        <div className="grid grid-cols-2 gap-3">
                                            <div>
                                                <label className="text-xs font-medium text-gray-700 block mb-1">
                                                    First name <span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    value={form.firstName}
                                                    onChange={e => set('firstName', e.target.value)}
                                                    onBlur={e => validateNameField('firstName', e.target.value)}
                                                    placeholder="First"
                                                    className={inputCls('firstName')}
                                                />
                                                <FieldError field="firstName" />
                                            </div>
                                            <div>
                                                <label className="text-xs font-medium text-gray-700 block mb-1">
                                                    Last name
                                                    <span className="text-gray-400 font-normal ml-1">(optional)</span>
                                                </label>
                                                <input
                                                    value={form.lastName}
                                                    onChange={e => set('lastName', e.target.value)}
                                                    onBlur={e => validateNameField('lastName', e.target.value)}
                                                    placeholder="Last"
                                                    className={inputCls('lastName')}
                                                />
                                                <FieldError field="lastName" />
                                            </div>
                                        </div>
                                        {!isEdit && (
                                            <div>
                                                <label className="text-xs font-medium text-gray-700 block mb-1">
                                                    Email <span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    value={form.email}
                                                    onChange={e => set('email', e.target.value)}
                                                    placeholder="priya@example.com"
                                                    className={inputCls('email')}
                                                />
                                                <FieldError field="email" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <div className="flex items-center gap-1.5 mb-1">
                                        <KeyRound size={13} className="text-gray-400" />
                                        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Reset Password</p>
                                    </div>
                                    {isInactive ? (
                                        <p className="text-xs text-amber-600 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2">
                                            This Content Creator is inactive. Activate the account before resetting the password.
                                        </p>
                                    ) : (
                                        <p className="text-xs text-gray-400 mb-3">
                                            Leave blank to keep the current password. Filling these fields will reset the Content Creator's password on save.
                                        </p>
                                    )}

                                    <div>
                                        <label className="text-xs font-medium text-gray-700 block mb-1">New Password</label>
                                        <div className="relative">
                                            <input
                                                type={showPwd.newPassword ? 'text' : 'password'}
                                                value={form.newPassword}
                                                disabled={isInactive}
                                                onChange={e => {
                                                    const val = e.target.value.replace(/ /g, '');
                                                    set('newPassword', val);
                                                    if (form.confirmNewPassword) {
                                                        setErrors(prev => ({
                                                            ...prev,
                                                            confirmNewPassword: val !== form.confirmNewPassword ? 'Passwords do not match.' : '',
                                                        }));
                                                    }
                                                }}
                                                onBlur={e => validatePasswordField('newPassword', e.target.value)}
                                                placeholder="Min. 4 characters"
                                                className={`${inputCls('newPassword')} ${isInactive ? 'bg-gray-50 cursor-not-allowed text-gray-400' : ''}`}
                                            />
                                            <button type="button" onClick={() => togglePwd('newPassword')} disabled={isInactive}
                                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 disabled:cursor-not-allowed">
                                                {showPwd.newPassword ? <EyeOff size={14} /> : <Eye size={14} />}
                                            </button>
                                        </div>
                                        <FieldError field="newPassword" />
                                    </div>
                                    <div>
                                        <label className="text-xs font-medium text-gray-700 block mb-1">Confirm New Password</label>
                                        <div className="relative">
                                            <input
                                                type={showPwd.confirmNewPassword ? 'text' : 'password'}
                                                value={form.confirmNewPassword}
                                                disabled={isInactive}
                                                onChange={e => set('confirmNewPassword', e.target.value.replace(/ /g, ''))}
                                                onBlur={e => {
                                                    const val = e.target.value;
                                                    if (val && form.newPassword !== val) {
                                                        setErrors(prev => ({ ...prev, confirmNewPassword: 'Passwords do not match.' }));
                                                    } else {
                                                        setErrors(prev => ({ ...prev, confirmNewPassword: '' }));
                                                    }
                                                }}
                                                placeholder="Re-enter new password"
                                                className={`${inputCls('confirmNewPassword')} ${isInactive ? 'bg-gray-50 cursor-not-allowed text-gray-400' : ''}`}
                                            />
                                            <button type="button" onClick={() => togglePwd('confirmNewPassword')} disabled={isInactive}
                                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 disabled:cursor-not-allowed">
                                                {showPwd.confirmNewPassword ? <EyeOff size={14} /> : <Eye size={14} />}
                                            </button>
                                        </div>
                                        <FieldError field="confirmNewPassword" />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {!isView && (
                        <div className="flex-shrink-0 border-t border-gray-100 px-5 py-4 space-y-3">
                            {errors.general && (
                                <p className="text-xs text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{errors.general}</p>
                            )}
                            <div className="flex gap-2">
                                <button onClick={handleCloseAttempt} className="flex-1 py-2.5 text-sm border border-gray-200 rounded-xl text-gray-600 hover:bg-gray-50 font-medium">
                                    Cancel
                                </button>
                                <button onClick={handleSubmit}
                                    disabled={saving || !!(form.newPassword && errors.confirmNewPassword)}
                                    className="flex-1 py-2.5 text-sm bg-purple-600 text-white rounded-xl hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium">
                                    {saving ? 'Saving...' : isEdit ? 'Save Changes' : 'Add Creator'}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </Modal>

            {showDiscard && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
                    <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-sm mx-4">
                        <h2 className="text-base font-semibold text-gray-900 mb-1">Discard changes?</h2>
                        <p className="text-sm text-gray-500 mb-6">
                            You have unsaved changes. They will be lost if you close now.
                        </p>
                        <div className="flex gap-3 justify-end">
                            <button
                                onClick={() => setShowDiscard(false)}
                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors"
                            >
                                Keep Editing
                            </button>
                            <button
                                onClick={handleDiscardConfirm}
                                className="px-4 py-2 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-lg transition-colors"
                            >
                                Discard
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

function ManagerDrawer({ mode, creator, onClose, onSaved }) {
    const isView = mode === 'view';
    const isEdit = mode === 'edit';
    const isInactive = isEdit && creator?.status !== 'ACTIVE';

    const [showPwd, setShowPwd] = useState({ newPassword: false, confirmNewPassword: false });
    const togglePwd = (field) => setShowPwd(p => ({ ...p, [field]: !p[field] }));
    const [form, setForm] = useState({
        firstName: creator?.firstName || '',
        lastName: creator?.lastName || '',
        email: creator?.email || '',
        newPassword: '',
        confirmNewPassword: '',
    });
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);
    const [showDiscard, setShowDiscard] = useState(false);
    const [isDirty, setIsDirty] = useState(false);

    const set = (k, v) => {
        setForm(f => ({ ...f, [k]: v }));
        setErrors(prev => ({ ...prev, [k]: '', general: '' }));
        setIsDirty(true);
    };

    const handleCloseAttempt = () => {
        if (!isView && isDirty) setShowDiscard(true);
        else onClose();
    };

    const validateNameField = (field, value) => {
        if (field === 'firstName') {
            if (!value || !value.trim()) setErrors(prev => ({ ...prev, firstName: 'First name is required.' }));
            else if (value !== value.trim()) setErrors(prev => ({ ...prev, firstName: 'Must not have leading or trailing spaces.' }));
            else if (!/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(value.trim())) setErrors(prev => ({ ...prev, firstName: 'Must contain only letters.' }));
            else setErrors(prev => ({ ...prev, firstName: '' }));
        }
        if (field === 'lastName') {
            if (value && !value.trim()) setErrors(prev => ({ ...prev, lastName: 'Last name cannot be spaces only.' }));
            else if (value && value !== value.trim()) setErrors(prev => ({ ...prev, lastName: 'Must not have leading or trailing spaces.' }));
            else if (value && !/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(value.trim())) setErrors(prev => ({ ...prev, lastName: 'Must contain only letters.' }));
            else setErrors(prev => ({ ...prev, lastName: '' }));
        }
    };

    const handleSubmit = async () => {
        const nameErr = validateNames(form.firstName, form.lastName, isEdit);
        if (nameErr) {
            if (nameErr.toLowerCase().includes('first')) setErrors(prev => ({ ...prev, firstName: nameErr }));
            else if (nameErr.toLowerCase().includes('last')) setErrors(prev => ({ ...prev, lastName: nameErr }));
            else setErrors(prev => ({ ...prev, general: nameErr }));
            return;
        }
        if (!isEdit) {
            const emailErr = validateEmail(form.email);
            if (emailErr) { setErrors(prev => ({ ...prev, email: emailErr })); return; }
        }
        if (isEdit && !isInactive && form.newPassword) {
            if (form.newPassword.startsWith(' ')) { setErrors(prev => ({ ...prev, newPassword: 'Password must not start with a space.' })); return; }
            if (form.newPassword.length < 4) { setErrors(prev => ({ ...prev, newPassword: 'New password must be at least 4 characters.' })); return; }
            if (form.newPassword !== form.confirmNewPassword) { setErrors(prev => ({ ...prev, confirmNewPassword: 'Passwords do not match.' })); return; }
        }

        setSaving(true);
        let res;
        if (isEdit) {
            const payload = { firstName: form.firstName.trim(), lastName: form.lastName.trim() };
            if (!isInactive && form.newPassword) payload.newPassword = form.newPassword;
            res = await tenantUserSvc.updateTenantUser(creator.id, payload);
        } else {
            res = await tenantUserSvc.createTenantUser({
                firstName: form.firstName.trim(),
                lastName: form.lastName.trim(),
                email: form.email.trim(),
                password: form.password,
                roleCode: 'MANAGER',
            });
        }
        setSaving(false);
        if (res.ok) onSaved();
        else setErrors(prev => ({ ...prev, general: res.data?.message || 'Something went wrong.' }));
    };

    const title = isView ? 'Manager Details' : isEdit ? 'Edit Manager' : 'Add Manager';
    const FieldError = ({ field }) => errors[field] ? <p className="text-xs text-red-500 mt-1">{errors[field]}</p> : null;
    const inputCls = (field) => `w-full border rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-200 ${errors[field] ? 'border-red-400' : 'border-gray-200'}`;

    return (
        <>
            <Modal title={title} open={true} toggle={handleCloseAttempt}>
                <div className="flex flex-col" style={{ height: 'calc(100vh - 80px)' }}>

                    <div className="flex-1 px-2 py-5 space-y-4 overflow-y-auto">
                        {isView ? (
                            <div className="space-y-4">
                                <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl">
                                    <Avatar first={creator.firstName} last={creator.lastName} size="lg" />
                                    <div className="min-w-0">
                                        <p className="font-semibold text-gray-900 text-sm">{creator.firstName} {creator.lastName}</p>
                                        <p className="text-xs text-gray-500 mt-0.5 truncate">{creator.email}</p>
                                        <div className="mt-1.5"><StatusPill status={creator.status} /></div>
                                    </div>
                                </div>
                                <div className="divide-y divide-gray-100 rounded-xl border border-gray-100 overflow-hidden">
                                    {[
                                        { label: 'Full Name', value: `${creator.firstName} ${creator.lastName}` },
                                        { label: 'Email', value: creator.email },
                                        { label: 'Role', value: 'Manager' },
                                    ].map(row => (
                                        <div key={row.label} className="flex items-center justify-between px-4 py-3 bg-white gap-3">
                                            <span className="text-xs text-gray-500 flex-shrink-0">{row.label}</span>
                                            <span className="text-sm text-gray-800 font-medium truncate text-right">{row.value}</span>
                                        </div>
                                    ))}
                                    <div className="flex items-center justify-between px-4 py-3 bg-white">
                                        <span className="text-xs text-gray-500">Status</span>
                                        <StatusPill status={creator.status} />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="space-y-5">
                                <div>
                                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Profile</p>
                                    <div className="space-y-3">
                                        <div className="grid grid-cols-2 gap-3">
                                            <div>
                                                <label className="text-xs font-medium text-gray-700 block mb-1">First name <span className="text-red-500">*</span></label>
                                                <input value={form.firstName} onChange={e => set('firstName', e.target.value)} onBlur={e => validateNameField('firstName', e.target.value)} placeholder="First" className={inputCls('firstName')} />
                                                <FieldError field="firstName" />
                                            </div>
                                            <div>
                                                <label className="text-xs font-medium text-gray-700 block mb-1">Last name <span className="text-gray-400 font-normal ml-1">(optional)</span></label>
                                                <input value={form.lastName} onChange={e => set('lastName', e.target.value)} onBlur={e => validateNameField('lastName', e.target.value)} placeholder="Last" className={inputCls('lastName')} />
                                                <FieldError field="lastName" />
                                            </div>
                                        </div>
                                        {!isEdit && (
                                            <div>
                                                <label className="text-xs font-medium text-gray-700 block mb-1">Email <span className="text-red-500">*</span></label>
                                                <input type="email" value={form.email}
                                                    onChange={e => {
                                                        const val = e.target.value.replace(/\s/g, '');
                                                        set('email', val);
                                                        setErrors(prev => ({ ...prev, email: val ? validateEmail(val) : '' }));
                                                    }}
                                                    placeholder="manager@example.com" className={inputCls('email')} />
                                                <FieldError field="email" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {isEdit && (
                                    <div>
                                        <div className="flex items-center gap-1.5 mb-1">
                                            <KeyRound size={13} className="text-gray-400" />
                                            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Reset Password</p>
                                        </div>
                                        {isInactive ? (
                                            <p className="text-xs text-amber-600 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2">
                                                This Manager is inactive. Activate the account before resetting the password.
                                            </p>
                                        ) : (
                                            <p className="text-xs text-gray-400 mb-3">Leave blank to keep current password.</p>
                                        )}
                                        <div>
                                            <label className="text-xs font-medium text-gray-700 block mb-1">New Password</label>
                                            <div className="relative">
                                                <input type={showPwd.newPassword ? 'text' : 'password'} value={form.newPassword} disabled={isInactive}
                                                    onChange={e => { const val = e.target.value.replace(/ /g, ''); set('newPassword', val); if (form.confirmNewPassword) setErrors(prev => ({ ...prev, confirmNewPassword: val !== form.confirmNewPassword ? 'Passwords do not match.' : '' })); }}
                                                    placeholder="Min. 4 characters" className={`${inputCls('newPassword')} ${isInactive ? 'bg-gray-50 cursor-not-allowed text-gray-400' : ''}`} />
                                                <button type="button" onClick={() => togglePwd('newPassword')} disabled={isInactive} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 disabled:cursor-not-allowed">
                                                    {showPwd.newPassword ? <EyeOff size={14} /> : <Eye size={14} />}
                                                </button>
                                            </div>
                                            <FieldError field="newPassword" />
                                        </div>
                                        <div>
                                            <label className="text-xs font-medium text-gray-700 block mb-1">Confirm New Password</label>
                                            <div className="relative">
                                                <input type={showPwd.confirmNewPassword ? 'text' : 'password'} value={form.confirmNewPassword} disabled={isInactive}
                                                    onChange={e => set('confirmNewPassword', e.target.value.replace(/ /g, ''))}
                                                    onBlur={e => { if (e.target.value && form.newPassword !== e.target.value) setErrors(prev => ({ ...prev, confirmNewPassword: 'Passwords do not match.' })); else setErrors(prev => ({ ...prev, confirmNewPassword: '' })); }}
                                                    placeholder="Re-enter new password" className={`${inputCls('confirmNewPassword')} ${isInactive ? 'bg-gray-50 cursor-not-allowed text-gray-400' : ''}`} />
                                                <button type="button" onClick={() => togglePwd('confirmNewPassword')} disabled={isInactive} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 disabled:cursor-not-allowed">
                                                    {showPwd.confirmNewPassword ? <EyeOff size={14} /> : <Eye size={14} />}
                                                </button>
                                            </div>
                                            <FieldError field="confirmNewPassword" />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {!isView && (
                        <div className="flex-shrink-0 border-t border-gray-100 px-2 py-4 space-y-3">
                            {errors.general && <p className="text-xs text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{errors.general}</p>}
                            <div className="flex gap-2">
                                <button onClick={handleCloseAttempt} className="flex-1 py-2.5 text-sm border border-gray-200 rounded-xl text-gray-600 hover:bg-gray-50 font-medium">Cancel</button>
                                <button onClick={handleSubmit} disabled={saving || !!(form.newPassword && errors.confirmNewPassword)}
                                    className="flex-1 py-2.5 text-sm bg-purple-600 text-white rounded-xl hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium">
                                    {saving ? 'Saving...' : isEdit ? 'Save Changes' : 'Add Manager'}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </Modal>

            {showDiscard && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
                    <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-sm mx-4">
                        <h2 className="text-base font-semibold text-gray-900 mb-1">Discard changes?</h2>
                        <p className="text-sm text-gray-500 mb-6">You have unsaved changes. They will be lost if you close now.</p>
                        <div className="flex gap-3 justify-end">
                            <button onClick={() => setShowDiscard(false)} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors">Keep Editing</button>
                            <button onClick={() => { setShowDiscard(false); onClose(); }} className="px-4 py-2 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-lg transition-colors">Discard</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

function MyProfile({ user, onUpdated }) {
    const [editing, setEditing] = useState(false);
    const [firstName, setFirst] = useState(user.firstName || '');
    const [lastName, setLast] = useState(user.lastName || '');
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});

    const validateField = (field, value) => {
        if (field === 'firstName') {
            if (!value || !value.trim()) {
                setErrors(prev => ({ ...prev, firstName: 'First name is required.' }));
            } else if (value !== value.trim()) {
                setErrors(prev => ({ ...prev, firstName: 'Must not have leading or trailing spaces.' }));
            } else if (!/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(value.trim())) {
                setErrors(prev => ({ ...prev, firstName: 'Must contain only letters.' }));
            } else {
                setErrors(prev => ({ ...prev, firstName: '' }));
            }
        }
        if (field === 'lastName') {
            if (value && !value.trim()) {
                setErrors(prev => ({ ...prev, lastName: 'Last name cannot be spaces only.' }));
            } else if (value && value !== value.trim()) {
                setErrors(prev => ({ ...prev, lastName: 'Must not have leading or trailing spaces.' }));
            } else if (value && !/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(value.trim())) {
                setErrors(prev => ({ ...prev, lastName: 'Must contain only letters.' }));
            } else {
                setErrors(prev => ({ ...prev, lastName: '' }));
            }
        }
    };

    const handleSave = async () => {
        const nameErr = validateNames(firstName, lastName);
        if (nameErr) {
            if (nameErr.toLowerCase().includes('first')) {
                setErrors(prev => ({ ...prev, firstName: nameErr }));
            } else {
                setErrors(prev => ({ ...prev, lastName: nameErr }));
            }
            return;
        }

        setSaving(true);
        setErrors({});
        const res = await tenantUserSvc.updateMe({ firstName: firstName.trim(), lastName: lastName.trim() });
        setSaving(false);
        if (res.ok) { setEditing(false); onUpdated(); }
        else setErrors(prev => ({ ...prev, general: res.data?.message || 'Failed to update.' }));
    };

    const handleCancel = () => {
        setFirst(user.firstName || '');
        setLast(user.lastName || '');
        setErrors({});
        setEditing(false);
    };

    const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ') || '-';

    const inputCls = (field) =>
        `w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-200 ${errors[field] ? 'border-red-400' : 'border-gray-200'
        }`;

    return (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100">
                <span className="text-sm font-semibold text-gray-900">My Profile</span>
            </div>
            <div className="px-6 py-5 space-y-5">
                <div className="flex items-center gap-3">
                    <Avatar first={user.firstName} last={user.lastName} size="lg" />
                    <div className="min-w-0">
                        <p className="font-semibold text-gray-900 text-sm">{fullName}</p>
                        <div className="flex items-center gap-2 mt-1.5 flex-wrap">
                            <span className="inline-flex items-center gap-1 text-xs bg-purple-50 text-purple-700 border border-purple-100 px-2 py-0.5 rounded-full font-medium">
                                <Shield size={10} /> Client Admin
                            </span>
                            <StatusPill status={user.status} />
                        </div>
                    </div>
                </div>

                <div className="divide-y divide-gray-100">
                    <div className="py-3">
                        <p className="text-xs text-gray-500 mb-1">Full Name</p>
                        {editing ? (
                            <div className="space-y-3">
                                <div className="grid grid-cols-2 gap-2">
                                    <div>
                                        <label className="text-xs text-gray-400 block mb-1">
                                            First name <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            value={firstName}
                                            onChange={e => { setFirst(e.target.value); setErrors(p => ({ ...p, firstName: '', general: '' })); }}
                                            onBlur={e => validateField('firstName', e.target.value)}
                                            className={inputCls('firstName')}
                                            placeholder="First"
                                        />
                                        {errors.firstName && <p className="text-xs text-red-500 mt-1">{errors.firstName}</p>}
                                    </div>
                                    <div>
                                        <label className="text-xs text-gray-400 block mb-1">
                                            Last name
                                            <span className="text-gray-400 font-normal ml-1">(optional)</span>
                                        </label>
                                        <input
                                            value={lastName}
                                            onChange={e => { setLast(e.target.value); setErrors(p => ({ ...p, lastName: '', general: '' })); }}
                                            onBlur={e => validateField('lastName', e.target.value)}
                                            className={inputCls('lastName')}
                                            placeholder="Last"
                                        />
                                        {errors.lastName && <p className="text-xs text-red-500 mt-1">{errors.lastName}</p>}
                                    </div>
                                </div>
                                {errors.general && <p className="text-xs text-red-500">{errors.general}</p>}
                                <div className="flex gap-2">
                                    <button onClick={handleCancel} className="flex-1 text-xs text-gray-600 border border-gray-200 rounded-lg py-2 hover:bg-gray-50 font-medium">Cancel</button>
                                    <button onClick={handleSave} disabled={saving} className="flex-1 text-xs bg-purple-600 text-white rounded-lg py-2 hover:bg-purple-700 disabled:opacity-50 font-medium">
                                        {saving ? 'Saving...' : 'Save'}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="flex items-center justify-between">
                                <span className="text-sm text-gray-800 font-medium">{fullName}</span>
                                <button onClick={() => setEditing(true)} className="flex items-center gap-1 text-xs text-gray-500 border border-gray-200 px-2.5 py-1 rounded-lg hover:bg-gray-50 hover:text-purple-700 font-medium">
                                    <Pencil size={11} /> Edit
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="py-3">
                        <p className="text-xs text-gray-500 mb-1">Email</p>
                        <div className="flex items-center gap-1.5">
                            <Mail size={13} className="text-gray-400 flex-shrink-0" />
                            <span className="text-sm text-gray-800 font-medium truncate">{user.email}</span>
                        </div>
                        <p className="text-xs text-gray-400 mt-1">Email cannot be changed. Contact your Super Admin if an update is needed.</p>
                    </div>

                    <div className="py-3">
                        <p className="text-xs text-gray-500 mb-1">Role</p>
                        <div className="flex items-center gap-1.5">
                            <Shield size={13} className="text-gray-400 flex-shrink-0" />
                            <span className="text-sm text-gray-800 font-medium">Client Admin</span>
                        </div>
                        <p className="text-xs text-gray-400 mt-1">Role is assigned by your Super Admin and cannot be changed here.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

function CreatorCard({ c, onView, onEdit, onToggle }) {
    const [open, setOpen] = useState(false);
    return (
        <div className="flex items-center gap-3 px-4 py-3 border-b border-gray-100 last:border-0">
            <Avatar first={c.firstName} last={c.lastName} />
            <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">{c.firstName} {c.lastName}</p>
                <p className="text-xs text-gray-400 truncate">{c.email}</p>
            </div>
            <StatusPill status={c.status} />
            <div className="relative">
                <button onClick={() => setOpen(o => !o)} className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-400">
                    <MoreVertical size={14} />
                </button>
                {open && (
                    <>
                        <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
                        <div className="absolute right-0 top-8 z-20 bg-white border border-gray-100 rounded-xl shadow-lg py-1 min-w-[130px]">
                            <button onClick={() => { setOpen(false); onView(c); }} className="w-full text-left text-sm px-3 py-2 hover:bg-gray-50 text-gray-700">View</button>
                            <button onClick={() => { setOpen(false); onEdit(c); }} className="w-full text-left text-sm px-3 py-2 hover:bg-gray-50 text-gray-700">Edit</button>
                            {c.lastlogin && <button onClick={() => { setOpen(false); onToggle(c); }} className={`w-full text-left text-sm px-3 py-2 hover:bg-gray-50 ${c.status === 'ACTIVE' ? 'text-red-600' : 'text-emerald-600'}`}>
                                {c.status === 'ACTIVE' ? 'Deactivate' : 'Activate'}
                            </button>}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

function CreatorsTable({ creators, loading, onAdd, onView, onEdit, onToggle, emptyLabel }) {
    if (loading) {
        return (
            <div className="divide-y divide-gray-50">
                {[1, 2, 3].map(i => (
                    <div key={i} className="flex items-center gap-4 px-5 py-4 animate-pulse">
                        <div className="w-8 h-8 rounded-full bg-gray-200 flex-shrink-0" />
                        <div className="flex-1 space-y-1.5">
                            <div className="h-3 bg-gray-200 rounded w-32" />
                            <div className="h-3 bg-gray-100 rounded w-44" />
                        </div>
                        <div className="h-5 w-14 bg-gray-100 rounded-full" />
                        <div className="h-7 w-28 bg-gray-100 rounded-lg" />
                    </div>
                ))}
            </div>
        );
    }

    if (creators.length === 0) {
        return (
            <div className="py-14 flex flex-col items-center text-center">
                <div className="w-12 h-12 rounded-full bg-purple-50 flex items-center justify-center mb-3">
                    <UserPlus size={20} className="text-purple-400" />
                </div>
                <p className="text-sm font-medium text-gray-700">{emptyLabel || 'No content creators found'}</p>
                {/* <p className="text-xs text-gray-400 mt-1">Try a different search or add a new creator</p> */}
            </div>
        );
    }

    return (
        <>
            <div className="sm:hidden">
                {creators.map(c => (
                    <CreatorCard key={c.id} c={c} onView={onView} onEdit={onEdit} onToggle={onToggle} />
                ))}
            </div>

            <div className="hidden sm:block overflow-x-auto">
                <table className="w-full min-w-[600px] border-collapse">
                    <thead>
                        <tr className="bg-gray-50 border-b border-gray-100">
                            <th className="text-left text-xs font-semibold text-gray-400 uppercase tracking-wide px-5 py-2.5 w-48">Name</th>
                            <th className="text-left text-xs font-semibold text-gray-400 uppercase tracking-wide px-4 py-2.5">Email</th>
                            <th className="text-left text-xs font-semibold text-gray-400 uppercase tracking-wide px-4 py-2.5 w-24">Status</th>
                            <th className="text-right text-xs font-semibold text-gray-400 uppercase tracking-wide px-5 py-2.5 w-56">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50">
                        {creators.map(c => (
                            <tr key={c.id} className="hover:bg-gray-50/60">
                                <td className="px-5 py-3.5">
                                    <div className="flex items-center gap-3">
                                        <Avatar first={c.firstName} last={c.lastName} />
                                        <span className="text-sm font-medium text-gray-800 truncate max-w-[120px]">{c.firstName} {c.lastName}</span>
                                    </div>
                                </td>
                                <td className="px-4 py-3.5">
                                    <span className="text-sm text-gray-500 truncate block max-w-[220px]">{c.email}</span>
                                </td>
                                <td className="px-4 py-3.5">
                                    <StatusPill status={c.status} />
                                </td>
                                <td className="px-5 py-3.5">
                                    <div className="flex items-center justify-end gap-1.5">
                                        <button onClick={() => onView(c)} className="flex items-center gap-1 text-xs text-gray-500 hover:text-purple-700 px-2 py-1.5 rounded-lg hover:bg-purple-50 whitespace-nowrap">
                                            <Eye size={12} /> View
                                        </button>
                                        <button onClick={() => onEdit(c)} className="flex items-center gap-1 text-xs text-gray-500 hover:text-purple-700 px-2 py-1.5 rounded-lg hover:bg-purple-50 whitespace-nowrap">
                                            <Pencil size={12} /> Edit
                                        </button>
                                        {c.lastlogin ? (
                                            <button onClick={() => onToggle(c)} className={`text-xs px-2.5 py-1.5 rounded-lg font-medium border whitespace-nowrap w-[90px] text-center ${c.status === 'ACTIVE'
                                                ? 'text-red-500 border-red-200 hover:bg-red-50'
                                                : 'text-emerald-600 border-emerald-200 hover:bg-emerald-50'
                                                }`}>
                                                {c.status === 'ACTIVE' ? 'Deactivate' : 'Activate'}
                                            </button>
                                        ) : (
                                            <span className="w-[90px]" aria-hidden="true" />
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

function Pagination({ page, total, size, onChange }) {
    const totalPages = Math.max(1, Math.ceil(total / size));
    const from = total === 0 ? 0 : page * size + 1;
    const to = Math.min((page + 1) * size, total);

    return (
        <div className="flex items-center justify-between px-5 py-3 border-t border-gray-100 bg-white">
            <p className="text-xs text-gray-400">
                {total === 0 ? 'No results' : `${from}-${to} of ${total}`}
            </p>
            <div className="flex items-center gap-1">
                <button onClick={() => onChange(page - 1)} disabled={page === 0}
                    className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 text-gray-500 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
                    <ChevronLeft size={14} />
                </button>
                <span className="text-xs text-gray-600 px-2 font-medium">{page + 1} / {totalPages}</span>
                <button onClick={() => onChange(page + 1)} disabled={page >= totalPages - 1}
                    className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 text-gray-500 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
                    <ChevronRight size={14} />
                </button>
            </div>
        </div>
    );
}

function Toast({ message }) {
    if (!message) return null;
    return (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-gray-900 text-white text-sm px-5 py-3 rounded-xl shadow-xl">
            {message}
        </div>
    );
}

export default function UsersRoles() {
    const [profile, setProfile] = useState(null);
    const clientId = useSelector((state) => state.userInfo?.clientId);

    const [featureToggleMode, setFeatureToggleMode] = useState(null);
    const [creators, setCreators] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [loadingProfile, setLoadingProfile] = useState(true);
    const [loadingCreators, setLoadingCreators] = useState(true);
    const [drawer, setDrawer] = useState(null);
    const [toast, setToast] = useState('');
    const [confirmTarget, setConfirmTarget] = useState(null);
    const debounceRef = useRef(null);

    // Manager state
    const [managers, setManagers] = useState([]);
    const [mgrTotal, setMgrTotal] = useState(0);
    const [mgrPage, setMgrPage] = useState(0);
    const [mgrSearch, setMgrSearch] = useState('');
    const [mgrDebouncedSearch, setMgrDebouncedSearch] = useState('');
    const [loadingManagers, setLoadingManagers] = useState(true);
    const [mgrDrawer, setMgrDrawer] = useState(null);
    const mgrDebounceRef = useRef(null);

    const [mgrConfirmTarget, setMgrConfirmTarget] = useState(null);

    const isFullCreator = featureToggleMode === 'FULL_CREATOR';

    const showToast = msg => { setToast(msg); setTimeout(() => setToast(''), 3000); };

    const loadProfile = useCallback(() => {
        setLoadingProfile(true);
        tenantUserSvc.getMe()
            .then(r => {
                if (r.ok) {
                    setProfile(r.data);
                    setFeatureToggleMode(r.data?.featureToggleMode || 'RUN_ONLY');
                }
            })
            .finally(() => setLoadingProfile(false));
    }, []);

    const loadCreators = useCallback((pg, q) => {
        setLoadingCreators(true);
        tenantUserSvc.getTenantUsers(clientId, pg, PAGE_SIZE, q, 'CONTENT_WRITER', '')
            .then(r => {
                if (r.ok) {
                    setCreators(r.data?.users || []);
                    setTotal(r.data?.total || 0);
                }
            })
            .finally(() => setLoadingCreators(false));
    }, [clientId]);

    const loadManagers = useCallback((pg, q) => {
        setLoadingManagers(true);
        tenantUserSvc.getTenantUsers(clientId, pg, PAGE_SIZE, q, 'MANAGER', '')
            .then(r => {
                if (r.ok) {
                    setManagers(r.data?.users || []);
                    setMgrTotal(r.data?.total || 0);
                }
            })
            .finally(() => setLoadingManagers(false));
    }, [clientId]);

    useEffect(() => { loadProfile(); }, [loadProfile]);
    useEffect(() => { loadCreators(page, debouncedSearch); }, [page, debouncedSearch, loadCreators]);
    useEffect(() => { loadManagers(mgrPage, mgrDebouncedSearch); }, [mgrPage, mgrDebouncedSearch, loadManagers]);

    const handleSearchChange = e => {
        const val = e.target.value;
        setSearch(val);
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => { setPage(0); setDebouncedSearch(val); }, 350);
    };

    const handleMgrSearchChange = e => {
        const val = e.target.value;
        setMgrSearch(val);
        clearTimeout(mgrDebounceRef.current);
        mgrDebounceRef.current = setTimeout(() => { setMgrPage(0); setMgrDebouncedSearch(val); }, 350);
    };

    const handleToggle = (creator) => {
        setConfirmTarget(creator);
    };

    const handleConfirmToggle = async () => {
        const creator = confirmTarget;
        setConfirmTarget(null);
        const isActive = creator.status !== 'ACTIVE';
        const res = await tenantUserSvc.toggleTenantUser(creator.id, isActive);
        if (res.ok) {
            showToast(`${creator.firstName} ${creator.lastName} ${isActive ? 'activated' : 'deactivated'}.`);
            loadCreators(page, debouncedSearch);
        }
    };

    const handleMgrToggle = (mgr) => {
        setMgrConfirmTarget(mgr);
    };

    const handleMgrConfirmToggle = async () => {
        const mgr = mgrConfirmTarget;
        setMgrConfirmTarget(null);
        const isActive = mgr.status !== 'ACTIVE';
        const res = await tenantUserSvc.toggleTenantUser(mgr.id, isActive);
        if (res.ok) {
            showToast(`${mgr.firstName} ${mgr.lastName} ${isActive ? 'activated' : 'deactivated'}.`);
            loadManagers(mgrPage, mgrDebouncedSearch);
        }
    };

    const handleSaved = () => {
        const msg = drawer?.mode === 'edit' ? 'Creator updated.' : 'Creator added. A welcome email has been sent.';
        setDrawer(null);
        showToast(msg);
        if (drawer?.mode !== 'edit') setPage(0);
        loadCreators(drawer?.mode === 'edit' ? page : 0, debouncedSearch);
    };

    const handleMgrSaved = () => {
        const msg = mgrDrawer?.mode === 'edit' ? 'Manager updated.' : 'Manager added. A welcome email has been sent.';
        setMgrDrawer(null);
        showToast(msg);
        if (mgrDrawer?.mode !== 'edit') setMgrPage(0);
        loadManagers(mgrDrawer?.mode === 'edit' ? mgrPage : 0, mgrDebouncedSearch);
    };

    return (
        <Page title="Users & Roles">
            <div className="px-4 py-4 sm:px-6 space-y-5">

                <div className="flex items-center justify-between">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900 mb-1">Users &amp; Roles</h1>
                        <p className="text-gray-600 text-sm">Manage your admin profile and organisation users</p>
                    </div>
                </div>

                {loadingProfile ? (
                    <div className="bg-white border border-gray-100 shadow-sm p-5 rounded-2xl animate-pulse">
                        <div className="flex items-center gap-3 mb-4">
                            <div className="w-12 h-12 rounded-full bg-gray-200" />
                            <div className="space-y-2">
                                <div className="h-3.5 bg-gray-200 rounded w-32" />
                                <div className="h-3 bg-gray-100 rounded w-24" />
                            </div>
                        </div>
                        <div className="h-3 bg-gray-100 rounded w-48" />
                    </div>
                ) : profile ? (
                    <MyProfile user={profile} onUpdated={loadProfile} />
                ) : null}

                {isFullCreator ? (
                    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
                        <div className="flex items-center justify-between px-4 sm:px-5 py-4 border-b border-gray-100">
                            <div>
                                <h2 className="text-sm font-semibold text-gray-900">Content Creators</h2>
                                <p className="text-xs text-gray-400 mt-0.5 hidden sm:block">
                                    Content Creators manage your organisation's private content bank.
                                </p>
                            </div>
                            <button onClick={() => setDrawer({ mode: 'add' })}
                                className="flex items-center gap-1.5 bg-purple-600 text-white text-xs sm:text-sm px-3 sm:px-4 py-2 rounded-xl hover:bg-purple-700 font-medium flex-shrink-0">
                                <UserPlus size={14} />
                                <span className="hidden sm:inline">Add Content Creator</span>
                                <span className="sm:hidden">Add</span>
                            </button>
                        </div>

                        <div className="px-4 sm:px-5 py-3 border-b border-gray-100 bg-gray-50/50">
                            <div className="relative max-w-sm">
                                <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                <input type="text" value={search} onChange={handleSearchChange}
                                    placeholder="Search by name" autoComplete="off" name="creator-search"
                                    className="w-full pl-8 pr-3 py-2 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:border-purple-400 focus:ring-1 focus:ring-purple-200" />
                            </div>
                        </div>

                        <CreatorsTable
                            creators={creators} loading={loadingCreators}
                            onAdd={() => setDrawer({ mode: 'add' })}
                            onView={c => setDrawer({ mode: 'view', creator: c })}
                            onEdit={c => setDrawer({ mode: 'edit', creator: c })}
                            onToggle={handleToggle}
                        />

                        {!loadingCreators && total > 0 && (
                            <Pagination page={page} total={total} size={PAGE_SIZE} onChange={p => setPage(p)} />
                        )}
                    </div>
                ) : featureToggleMode !== null && (
                    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
                        <div className="px-4 sm:px-5 py-4 border-b border-gray-100">
                            <h2 className="text-sm font-semibold text-gray-900">Content Creators</h2>
                        </div>
                        <div className="px-5 py-6 flex items-start gap-3">
                            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-amber-50 flex items-center justify-center mt-0.5">
                                <Info size={15} className="text-amber-500" />
                            </div>
                            <div>
                                <p className="text-sm font-medium text-gray-800">
                                    Content Creator management is available for Full Creator tenants only.
                                </p>
                                <p className="text-xs text-gray-500 mt-1">
                                    This tenant is configured in Run-Only mode - all content is provided by keySkillset.
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                {/* Managers Section - visible for both RUN_ONLY and FULL_CREATOR */}
                {featureToggleMode !== null && (
                    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
                        <div className="flex items-center justify-between px-4 sm:px-5 py-4 border-b border-gray-100">
                            <div>
                                <h2 className="text-sm font-semibold text-gray-900">Managers</h2>
                                <p className="text-xs text-gray-400 mt-0.5 hidden sm:block">
                                    Managers oversee learner progress and manage team activities.
                                </p>
                            </div>
                            <button onClick={() => setMgrDrawer({ mode: 'add' })}
                                className="flex items-center gap-1.5 bg-purple-600 text-white text-xs sm:text-sm px-3 sm:px-4 py-2 rounded-xl hover:bg-purple-700 font-medium flex-shrink-0">
                                <UserPlus size={14} />
                                <span className="hidden sm:inline">Add Manager</span>
                                <span className="sm:hidden">Add</span>
                            </button>
                        </div>

                        <div className="px-4 sm:px-5 py-3 border-b border-gray-100 bg-gray-50/50">
                            <div className="relative max-w-sm">
                                <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                <input type="text" value={mgrSearch} onChange={handleMgrSearchChange}
                                    placeholder="Search by name" autoComplete="off" name="manager-search"
                                    className="w-full pl-8 pr-3 py-2 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:border-purple-400 focus:ring-1 focus:ring-purple-200" />
                            </div>
                        </div>

                        <CreatorsTable
                            creators={managers} loading={loadingManagers}
                            onAdd={() => setMgrDrawer({ mode: 'add' })}
                            onView={c => setMgrDrawer({ mode: 'view', creator: c })}
                            onEdit={c => setMgrDrawer({ mode: 'edit', creator: c })}
                            onToggle={handleMgrToggle}
                            emptyLabel="No managers found"
                        />

                        {!loadingManagers && mgrTotal > 0 && (
                            <Pagination page={mgrPage} total={mgrTotal} size={PAGE_SIZE} onChange={p => setMgrPage(p)} />
                        )}
                    </div>
                )}
            </div>

            {drawer && isFullCreator && (
                <CreatorDrawer mode={drawer.mode} creator={drawer.creator}
                    onClose={() => setDrawer(null)} onSaved={handleSaved} />
            )}

            {mgrDrawer && (
                <ManagerDrawer mode={mgrDrawer.mode} creator={mgrDrawer.creator}
                    onClose={() => setMgrDrawer(null)} onSaved={handleMgrSaved} />
            )}

            {confirmTarget && (
                <ConfirmModal
                    creator={confirmTarget}
                    onConfirm={handleConfirmToggle}
                    onCancel={() => setConfirmTarget(null)}
                />
            )}

            {mgrConfirmTarget && (
                <ConfirmModal
                    creator={mgrConfirmTarget}
                    onConfirm={handleMgrConfirmToggle}
                    onCancel={() => setMgrConfirmTarget(null)}
                />
            )}

            <Toast message={toast} />
        </Page>
    );
}